module.exports = __webpack_public_path__ + "img/city.1181bc5.jpg";